import WarehouseService from '../services/warehouse.service';
import {
  Warehouse, Location, Stock, Region, Company,
} from './models/models';

export default {
  namespaced: true,
  state: {
    warehouseId: null,
    totalWarehouses: null,
    query: {
      filters: {},
      sort: [],
      page: 1,
      limit: 30,
    },
    stocksDate: null,
  },
  mutations: {
    warehouseId(state, warehouseId) {
      state.warehouseId = warehouseId;
    },
    totalWarehouses(state, totalWarehouses) {
      state.totalWarehouses = totalWarehouses;
    },
    queryProps(state, props) {
      state.query = Object.assign({}, state.query, props);
    },
    stocksDate(state, stocksDate) {
      state.stocksDate = stocksDate;
    },
  },
  actions: {
    init({ dispatch }) {
      dispatch('getCompanies');
      dispatch('getRegions');
    },
    newWarehouse({ commit }) {
      Warehouse.new()
        .then((warehouse) => {
          commit('warehouseId', warehouse.id);
        });
    },
    updateWarehouseProps({ state }, props) {
      if (props.hasOwnProperty('location')) {
        Location.insert({ data: props.location });
      }

      if (props.hasOwnProperty('region')) {
        Region.insert({ data: props.region });
      }

      if (props.hasOwnProperty('company')) {
        Company.insert({ data: props.company });
      }

      Warehouse.update({
        where: state.warehouseId,
        data: props,
      });
    },
    getWarehouses({ commit, state }) {
      return WarehouseService.getWarehouses(state.query)
        .then((res) => {
          commit('totalWarehouses', res.total);
          Warehouse.create({
            data: res.data,
            insertOrUpdate: ['countries', 'companies', 'regions'],
          });
        });
    },
    getStocks({ state }, query) {
      query.date = state.stocksDate;
      return WarehouseService.getStocks(query)
        .then((res) => {
          Stock.create({
            data: res,
            insertOrUpdate: ['products', 'warehouses', 'regions'],
          });
        });
    },
    exportToXlSX(store, props) {
      return WarehouseService.exportToXlSX(props);
    },
    suggestWarehouses(store, query) {
      return WarehouseService.suggestWarehouses(query);
    },
    getWarehouse({ commit }, id) {
      return WarehouseService.getWarehouse(id)
        .then((warehouse) => {
          Warehouse.insert({ data: [warehouse] })
            .then(() => {
              commit('warehouseId', warehouse.id);
            });
        });
    },
    createWarehouse({ getters }) {
      return WarehouseService.createWarehouse(getters.warehouse);
    },
    updateWarehouse({ getters, dispatch }) {
      return WarehouseService.updateWarehouse(getters.warehouse)
        .then((res) => {
          if (res.hasOwnProperty('warehouse_id')) {
            dispatch('getWarehouse', res.warehouse_id);
          }
          return res;
        });
    },
    deleteWarehouse({ getters }) {
      return WarehouseService.deleteWarehouse(getters.warehouse)
        .then((res) => {
          if (res.hasOwnProperty('warehouse_id')) {
            Warehouse.delete(res.warehouse_id);
          }
          return res;
        });
    },
  },
  getters: {
    warehouses() {
      return Warehouse.query()
        .with(['location.country', 'location.region'])
        .get();
    },
    warehouse(state) {
      if (!state.warehouseId) {
        return null;
      }
      return Warehouse.query()
        .withAllRecursive()
        .find(state.warehouseId);
    },
    stocks() {
      return Stock.query()
        .with(['warehouse.location', 'product', 'product.types'])
        .get();
    },
  },
};
